module.exports = "\n\n\n\n@media (min-width: 1280px) {\n\n\n\n }\n\n @media (min-width: 1360px) {\n\n\n\n }\n\n @media (min-width: 1440px) {\n\n\n\n }\n\n @media (min-width: 1600px) {\n\n\n\n }\n\n @media (min-width: 1920px) {\n\n\n }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/footer/footer.component.css
// module id = ./src/app/shared/footer/footer.component.css
// module chunks = main